import { Dispatch, SetStateAction, useState } from 'react';
import { DrawApi } from '@apply/api';
import store, { inspectionActions } from '@apply/adminStore';
import React from 'react';

interface IInspectionButtonParameters {
    drawBudget: DrawApi.IDrawBudget | undefined;
    set_drawBudget: Dispatch<SetStateAction<DrawApi.IDrawBudget | undefined>>;
}
export const InspectionButton = ({ drawBudget, set_drawBudget }: IInspectionButtonParameters): JSX.Element => {
    const { dispatch } = store;

    const ReadOnlyInspectionButton = ({ title }) => {
        return (
            <button
                id='inspectionButton'
                className='button primary readOnly'
                title={title}
            >
                Inspections
            </button>
        );
    };

    const onInspectionClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!drawBudget?.id || drawBudget.id <= 0) {
            return;
        }
        dispatch(
            inspectionActions.setInspectionsModal({
                inspectionsModal: {
                    isOpen: true,
                    drawBudgetId: drawBudget.id,
                    set_drawBudget,
                },
            }) as never
        );
    };

    const isApproved = drawBudget && drawBudget.currentApproval;

    if (!isApproved) return <ReadOnlyInspectionButton title={'Budget must be approved before adding inspections.'} />;

    return (
        <button
            id='inspectionButton'
            className='button primary'
            onClick={(e) => onInspectionClick(e)}
            title='List, View & Order Inspections'
        >
            Inspections
        </button>
    );
};
